var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 548.2 548.2",
    style: {
      enableBackground: "new 0 0 548.2 548.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00ABF9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534.8,68.2c-8.9-8.9-19.7-13.4-32.3-13.4H45.7c-12.6,0-23.3,4.5-32.3,13.4C4.5,77.2,0,87.9,0,100.5v347.2 c0,12.6,4.5,23.3,13.4,32.3c9,8.9,19.7,13.4,32.3,13.4h456.8c12.6,0,23.3-4.5,32.3-13.4c8.9-8.9,13.4-19.7,13.4-32.3V100.5 C548.2,87.9,543.7,77.2,534.8,68.2z M511.6,447.7c0,2.5-0.9,4.6-2.7,6.4c-1.8,1.8-3.9,2.7-6.4,2.7H45.7c-2.5,0-4.6-0.9-6.4-2.7 c-1.8-1.8-2.7-3.9-2.7-6.4V274.1h475.1L511.6,447.7L511.6,447.7z M511.6,164.4H36.5v-64c0-2.5,0.9-4.6,2.7-6.4 c1.8-1.8,4-2.7,6.4-2.7h456.8c2.5,0,4.6,0.9,6.4,2.7c1.8,1.8,2.7,3.9,2.7,6.4L511.6,164.4L511.6,164.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.1,
    y: 383.7,
    className: "st0",
    width: 73.1,
    height: 36.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.7,
    y: 383.7,
    className: "st0",
    width: 109.6,
    height: 36.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.5df9af2f6cd0b18f9c09112586d04458.svg";
export { ForwardRef as ReactComponent };